import { cn } from '@woonstad/helpers-utils';
import { forwardRef } from 'react';

type Props = {
  icon: React.ReactNode;
  className?: string;
  label: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * Een icon button component.
 *
 */
export const IconButton = forwardRef<HTMLButtonElement, Props>((
  {
    icon,
    className,
    label,
    ...restProps
  },
  ref,
) => {

  return (
    <button
      ref={ref}
      className={cn(
        'size-10 bg-icon-button-enabled p-2 hover:bg-icon-button-hover',
        restProps.disabled && 'bg-icon-button-disabled',
        className,
      )}
      {...restProps}
    >
      {icon}
      <span className="sr-only">{label}</span>
    </button>
  );
});

IconButton.displayName = 'IconButton';
